<style lang="less" scoped>
@import '../../../style/common/variable';
.tabsList {position: relative;text-align: left;font-family: AlibabaPuHuiTi-Regular;width: 810px;height: 216px;}
.type{margin: 45px 0px 0px 0px;padding-top:5px;width: 810px;height: 30px;
  .left{float: left;
  .icon{display: inline-block;width: 10px;height: 18px;background-color: rgb(9, 182, 250);margin: 0px 10px -2px 0px;vertical-align: baseline;}
  span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;cursor: pointer;
    span{font-size: 14px;font-weight: 600;}
    span:hover{color: #13569e;}
  }
}
.content {margin-top: 6px;width: 810px;}
 /deep/.el-tabs__item {font-size: 14px !important;color: #aaaaaa;}
 /deep/.el-tabs__item.is-active{color: #40bafd;}
 /deep/.el-tabs__active-bar{background: #40bafd;}
.el-tab-pane {font-size: 14px;width: 810px;}
ul{list-style: none;margin-left: -40px;margin-top: -10px;margin-left: -40px;}
.list span::before {content: "●";margin-right: 5px;}
.list {margin-top: 12px;width: 280px;margin-right: 120px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;float: left;}
.list:hover {color: #13569e;cursor: pointer;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .tabsList {height: auto;
    .type{width: 95vw;}
    .content{width: 94vw; margin-left: 3vw;
      ul{width: 100vw;
        .list{width: 90vw;margin-left: 5vw;}
      }
    }
  }
}
</style>

<template>
  <div class="tabsList">
    <div class="type">
      <div class="left">
        <div class="icon"></div><span>{{ tabsList.type }}</span>
      </div>
      <div class="right">
        <span @click="getmore(tabsList)"> {{ tabsList.button }} </span>
      </div>
    </div>
    <el-tabs class="content" v-model="activeName">
      <el-tab-pane v-for="(item, index) in tabsList.content" :key="index" :label="item.title" :name="item.name">
        <ul>
          <li class="list" v-for="(citem, cindex) in item.listdata" :key="cindex" @click="clickTabsList(citem)">
            <span v-if="cindex < 8">{{ citem.title }}</span>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
* 何宽  2021.7.2
* 该tabs标签页组件使用场景：每个标题包含不同多个不同的内容（以列表的形式），
    鼠标点击标题，面板上的内容切换到对应的标题下的内容；
    鼠标点击 列表项，返回相应的对象给父组件
*/

export default {
  props: ['tabsList'],
  data()
  {
    return {
      activeName: '1'
    }
  },
  methods: {
    // 点击更多，将对应的类型对象传递给父组件
    getmore(tabsList)
    {
      this.$emit('getmore', tabsList)
    },
    // 点击列表项，将选中的 列表对象 传递给父组件
    clickTabsList(citem)
    {
      this.$emit('clickTabsList', citem)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/TabsList.vue